// extracted by mini-css-extract-plugin
module.exports = {"service_RAIL_LANDSCAPE":"styles_service_RAIL_LANDSCAPE__1sluP","serviceTileText":"styles_serviceTileText__2v8iS"};